var Parse = require("ParseInit");

var BusinessPartner = Parse.Object.extend("businessPartner", {
    col: {
        ACL: "ACL",
        addressID: "addressID",
        createdAt: "createdAt",
        objectId: "objectId",
        paymentTargetID: "paymentTargetID",
        status: "status",
        updatedAt: "updatedAt"
    },
    getACL: function () {
        return this.get(this.col.ACL)
    },
    setACL: function (ACL) {
        return this.set(this.col.ACL, ACL)
    },
    getAddressID: function () {
        return this.get(this.col.addressID)
    },
    setAddressID: function (addressID) {
        return this.set(this.col.addressID, addressID)
    },
    getCreatedAt: function () {
        return this.get(this.col.createdAt)
    },
    getObjectId: function () {
        return this.get(this.col.objectId)
    },
    setObjectId: function (objectId) {
        return this.set(this.col.objectId, objectId)
    },
    getPaymentTargetID: function () {
        return this.get(this.col.paymentTargetID)
    },
    setPaymentTargetID: function (paymentTargetID) {
        return this.set(this.col.paymentTargetID, paymentTargetID)
    },
    getStatus: function () {
        return this.get(this.col.status)
    },
    setStatus: function (status) {
        return this.set(this.col.status, status)
    },
    getUpdatedAt: function () {
        return this.get(this.col.updatedAt)
    }
});

module.exports = BusinessPartner;
